import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';
import { getCategoryByKey } from '@/utils/movie';

interface MovieListItemProps {
  movie: Movie;
  highlight?: string;
}

function highlightText(text: string, keyword?: string) {
  if (!keyword || !keyword.trim()) return text;
  const q = keyword.trim();
  const idx = text.toLowerCase().indexOf(q.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="bg-accent-100 text-accent-800">{text.slice(idx, idx + q.length)}</mark>
      {text.slice(idx + q.length)}
    </>
  );
}

export default function MovieListItem({ movie, highlight }: MovieListItemProps) {
  const category = getCategoryByKey(movie.type);
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="h-32 w-[88px] shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}电影封面`}
          title={`${movie.title}高清电影封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
            {highlightText(movie.title, highlight)}
          </h3>
          <span className="flex shrink-0 items-center gap-1 text-sm font-bold text-accent-600">
            <i className="ri-star-fill text-xs"></i>
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <p className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-foreground-300">·</span>
          <span className="rounded bg-background-100 px-1.5 py-0.5 text-secondary-700">{category?.name}</span>
          <span className="rounded bg-background-100 px-1.5 py-0.5 text-foreground-600">{movie.region}</span>
          <span className="text-foreground-300">·</span>
          <span>导演 {movie.director}</span>
        </p>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{movie.synopsis}</p>
      </div>
    </Link>
  );
}